import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { useTours } from "../lib/useTours";
import TourCard from "../components/TourCard";
import { Button } from "../components/ui/button";

export default function PublicWishlist() {
  const { token } = useParams();
  const [share, setShare] = useState(null);
  const [error, setError] = useState(null);
  const { tours } = useTours();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/w/${token}`);
        setShare(data);
      } catch (e) {
        setError(e?.response?.status === 404 ? "notfound" : "error");
      }
    })();
  }, [token]);

  if (error === "notfound") {
    return (
      <main className="pt-32 pb-24 min-h-screen paper-texture text-center px-6">
        <Heart className="w-10 h-10 text-[#C87A50] mx-auto mb-4" />
        <h1 className="font-serif text-4xl text-[#1F4D3A] mb-4">This wishlist has moved on.</h1>
        <p className="text-[#5A4A38] mb-6">The share link was disabled or never existed.</p>
        <Link to="/tours" className="text-[#C87A50] font-semibold hover:underline">Explore all tours →</Link>
      </main>
    );
  }

  if (!share) {
    return (
      <main className="pt-32 pb-24 min-h-screen text-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#1F4D3A]/20 border-t-[#1F4D3A] animate-spin mx-auto" />
      </main>
    );
  }

  const list = tours.filter((t) => share.tour_ids.includes(t.id));

  return (
    <main className="pt-24 sm:pt-32 pb-16 paper-texture min-h-screen">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 sm:mb-14 text-center">
          <span className="leaf-divider inline-flex">Shared wishlist</span>
          <h1 className="font-serif text-3xl sm:text-5xl font-bold text-[#1F4D3A] mt-3">
            {share.user_name}'s <em className="text-[#C87A50] not-italic">road stories</em>
          </h1>
          <p className="text-[#4A3728] mt-3 max-w-2xl mx-auto">
            The trips they're dreaming about — tap any to see the full itinerary.
          </p>
        </div>

        {list.length === 0 ? (
          <div className="bg-white border border-[#E5DDCB] rounded-3xl p-14 text-center" data-testid="public-wishlist-empty">
            <Heart className="w-10 h-10 text-[#C87A50] mx-auto mb-4" />
            <h2 className="font-serif text-2xl font-bold text-[#1F4D3A]">Nothing on the list yet.</h2>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-testid="public-wishlist-grid">
            {list.map((t) => <TourCard key={t.id} tour={t} />)}
          </div>
        )}

        <div className="text-center mt-12">
          <Link to="/tours">
            <Button className="btn-primary bg-[#1F4D3A] hover:bg-[#2D6B4F] text-white rounded-full h-12 px-8">
              Explore all trips <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </main>
  );
}
